module.exports = __webpack_public_path__ + "img/influencer_thumbnail-600x450.5f50bf7c.jpg";